(function () {
  if (window.__FBR_WIDGET_LOADER_ACTIVE__) return;
  window.__FBR_WIDGET_LOADER_ACTIVE__ = true;

  var loaded = false;
  var selector = '.fbr-widget';
  var widgetScript = 'https://www.furniturebrandreviews.com/widget.js';

  function loadWidget() {
    if (loaded) return;
    if (!document.querySelector(selector)) return;
    if (document.querySelector('script[src*="furniturebrandreviews.com/widget.js"]')) {
      loaded = true;
      return;
    }

    loaded = true;

    var script = document.createElement('script');
    script.src = widgetScript;
    script.async = true;
    document.body.appendChild(script);
  }

  function loadWhenIdle() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadWidget, { timeout: 4500 });
      return;
    }
    window.setTimeout(loadWidget, 4500);
  }

  function observeWidget() {
    var target = document.querySelector(selector);
    if (!target || !('IntersectionObserver' in window)) {
      loadWhenIdle();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) {
        observer.disconnect();
        loadWidget();
      }
    }, { rootMargin: '300px 0px' });

    observer.observe(target);
    loadWhenIdle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeWidget);
  } else {
    observeWidget();
  }
})();
